import { MessageInstance } from 'antd/es/message/interface';
import { CanceledError } from 'axios';
import { useCallback, useEffect, useRef, useState } from 'react';

export function useFirstRender() {
  const ref = useRef(true);
  const firstRender = ref.current;
  ref.current = false;
  return firstRender;
}

export function useHTTP<DataType>(
  httpFn: () => Promise<DataType | null>,
  initialRequest: boolean = true,
  onError: string | ((err: Error) => string) = 'Error',
  messageApi?: MessageInstance
): [
  DataType | null,
  boolean,
  () => void,
  React.Dispatch<React.SetStateAction<boolean>>
] {
  const [data, setData] = useState<DataType | null>(null);
  const [loading, setLoading] = useState(initialRequest);
  const [requested, setRequested] = useState(initialRequest);
  const refresh = useCallback(() => {
    setRequested(true);
  }, []);
  useEffect(() => {
    if (!requested) return;
    setLoading(true);
    (async () => {
      try {
        const fetchedData = await httpFn();
        setData(fetchedData);
      } catch (error: any) {
        if (error instanceof CanceledError) return;
        const msg = typeof onError === 'string' ? onError : onError(error);
        if (msg && messageApi) {
          messageApi.error(msg);
        }
        console.log(msg, error);
      }
      setLoading(false);
      setRequested(false);
    })();
  }, [requested, httpFn, onError, messageApi]);

  return [data, loading, refresh, setRequested];
}
